module.exports = __webpack_public_path__ + "img/facturacion.e8dda2ea.png";